export default __webpack_public_path__ + "images/roche-logo.8c51ba304c006da7ce2f1aebcac1754b.png";